<template>
  <v-container>
    <v-data-table-server
      :headers="headers"
      :items="alumnos"
      item-key="id"
      :sort-by="[{ key: 'nombres', order: 'asc' }]"
      v-model:options="options"
      v-model:items-per-page="itemsPerPage"
      :items-length="totalItems"
      show-current-page
      :items-per-page-options="itemsPorPagina"
      @update:options="loadAlumnos($event)"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Gestión de Alumnos</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="openDialog">
            Nuevo Alumno
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:thead>
        <tr>
          <th>
            <v-text-field v-model="params.querynombres" label="Buscar Nombres" hide-details density="compact"
              class="mx-2" />
          </th>
          <th>
            <v-text-field v-model="params.queryapellido_paterno" label="Buscar Ap. Paterno" hide-details
              density="compact" class="mx-2" />
          </th>
          <th>
            <v-text-field v-model="params.queryapellido_materno" label="Buscar Ap. Materno" hide-details
              density="compact" class="mx-2" />
          </th>
          <th>
            <v-text-field v-model="params.querynumero_documento" label="Buscar Documento" hide-details density="compact"
              class="mx-2" />
          </th>
          <th>
            <v-text-field v-model="params.querygenero" label="Buscar Género" hide-details density="compact"
              class="mx-2" />
          </th>
          <th>
            <v-text-field v-model="params.querycelular" label="Buscar Celular" hide-details density="compact"
              class="mx-2" />
          </th>
          <th>
            <v-select v-model="params.querymedio_contacto" :items="mediosContacto" item-title="descripcion"
              item-value="id" label="Filtrar Medio" hide-details density="compact" clearable class="mx-2" />
          </th>
          <th></th>
        </tr>
      </template>

      <!-- Formatear nombres en mayúsculas -->
      <template v-slot:[`item.nombres`]="{ item }">
        {{ item.nombres.toUpperCase() }}
      </template>
      <template v-slot:[`item.apellido_paterno`]="{ item }">
        {{ item.apellido_paterno.toUpperCase() }}
      </template>
      <template v-slot:[`item.apellido_materno`]="{ item }">
        {{ item.apellido_materno.toUpperCase() }}
      </template>

      <!-- Medio de contacto -->
      <template v-slot:[`item.medio_contacto`]="{ item }">
        {{ item.medio_contacto || '—' }}
      </template>

      <!-- Acciones -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip text="Ver Detalles" location="top">
          <template v-slot:activator="{ props }">
            <v-icon class="me-2" size="small" v-bind="props" @click="editItem(item)">
              mdi-magnify
            </v-icon>
          </template>
        </v-tooltip>

        <v-tooltip text="Eliminar" location="top">
          <template v-slot:activator="{ props }">
            <v-icon size="small" color="red" v-bind="props" @click="confirmDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="loadAlumnos">Resetear</v-btn>
      </template>
    </v-data-table-server>

    <!-- Diálogo para crear/editar alumno -->
    <AlumnoDialog :dialog="dialog" :editedItem="editedItem" :formTitle="formTitle" @update:dialog="dialog = $event"
      @close="close" @saved="onAlumnoSaved" />

    <!-- Confirmación de eliminación -->
    <v-dialog v-model="dialogDelete" width="auto" persistent>
      <v-card class="mt-0" max-width="400" prepend-icon="mdi-delete" text="¿Está seguro de eliminar este alumno?"
        title="Eliminar Alumno">
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="red-darken-1" text @click="deleteItemConfirm">Eliminar</v-btn>
        </template>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" :color="snackbar.color">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AlumnoDialog from '@/components/alumno/NuevoAlumnoDialog.vue';

export default {
  components: {
    AlumnoDialog,
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      snackbar: { show: false, message: '', color: 'success', timeout: 3000 },
      headers: [
        { title: 'Nombres', value: 'nombres' },
        { title: 'Apellido Paterno', value: 'apellido_paterno' },
        { title: 'Apellido Materno', value: 'apellido_materno' },
        { title: 'Número de Documento', value: 'numero_documento' },
        { title: 'Género', value: 'genero.descripcion' },
        { title: 'Celular', value: 'celular' },
        { title: 'Medio de Contacto', value: 'medio_contacto', sortable: false },
        { title: 'Acciones', value: 'actions', sortable: false },
      ],
      mediosContacto: [],
      params: {
        querynombres: '',
        queryapellido_paterno: '',
        queryapellido_materno: '',
        querynumero_documento: '',
        querygenero: '',
        querycelular: '',
        querymedio_contacto: null,
      },
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      itemsPorPagina: [
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' },
        { value: 100, title: '100' },
      ],
      itemsPerPage: 10,
      options: { page: 1, itemsPerPage: 10 },
      totalItems: 0,
    };
  },
  computed: {
    ...mapGetters('alumno', ['alumnos']),
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Alumno' : 'Editar Alumno';
    },
  },
  created() {
    this.loadAlumnos();
    this.loadMediosContacto();
  },
  watch: {
    'params.querynombres': 'onFilterChange',
    'params.queryapellido_paterno': 'onFilterChange',
    'params.queryapellido_materno': 'onFilterChange',
    'params.querynumero_documento': 'onFilterChange',
    'params.querygenero': 'onFilterChange',
    'params.querycelular': 'onFilterChange',
    'params.querymedio_contacto': 'onFilterChange',
  },
  methods: {
    ...mapActions('alumno', ['fetchAlumnos', 'createAlumno', 'saveAlumno', 'deleteAlumno', 'fetchMediosContacto']),

    loadMediosContacto() {
      this.fetchMediosContacto()
        .then((data) => {
          this.mediosContacto = Array.isArray(data) ? data : data?.data ?? [];
        })
        .catch(() => {
          this.mediosContacto = [];
        });
    },

    onFilterChange() {
      // Al cambiar un filtro, volver a la primera página y recargar
      this.options = { ...this.options, page: 1 };
      this.loadAlumnos();
    },

    loadAlumnos(newOptions) {
      // newOptions solo es válido cuando viene de @update:options (un objeto con page/itemsPerPage)
      if (newOptions && typeof newOptions === 'object') {
        this.options = newOptions;
      }
      const params = {
        page: this.options.page,
        per_page: this.options.itemsPerPage,
      };
      Object.keys(this.params).forEach((key) => {
        const value = this.params[key];
        if (value) params[key] = value;
      });
      this.fetchAlumnos(params).then((data) => {
        const total = data?.meta?.total ?? data?.total ?? this.alumnos.length;
        this.totalItems = total;
        if (data?.current_page) this.options.page = data.current_page;
        if (data?.per_page) {
          this.itemsPerPage = data.per_page;
          this.options.itemsPerPage = data.per_page;
        }
      });
    },

    openDialog() {
      this.editedItem = { ...this.defaultItem };
      this.dialog = true;
    },

    editItem(item) {
      this.$router.push({ name: 'detallesAlumno', params: { id: item.id } });
    },

    confirmDelete(item) {
      this.editedIndex = this.alumnos.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.deleteAlumno(this.editedItem)
        .then(() => {
          this.loadAlumnos();
          this.closeDelete();
          this.mostrarSnackbar('Alumno eliminado');
        })
        .catch((error) => {
          const msg = error?.response?.data?.message || 'Error eliminando alumno';
          this.mostrarSnackbar(msg, 'error');
        });
    },

    mostrarSnackbar(msg, color = 'success') {
      this.snackbar = { show: true, message: msg, color, timeout: 3000 };
    },

    close() {
      this.dialog = false;
    },

    onAlumnoSaved() {
      this.loadAlumnos();
      this.mostrarSnackbar('Alumno guardado');
    },

    closeDelete() {
      this.dialogDelete = false;
    },
  },
};
</script>
